// L1 department tiles for the discovery screen (#63 AC1/AC2). 2-column grid with
// an emoji per department; tapping one filters the product list to that subtree.
import React from 'react';
import type { Category } from '../shared/types';
import { l1Departments, emojiForDepartment } from '../services/category-nav';

const CategoryTiles: React.FC<{ categories: Category[]; onSelect: (l1Id: string) => void }> = ({ categories, onSelect }) => {
  const departments = l1Departments(categories);
  if (departments.length === 0) return null;

  return (
    <div className="max-w-3xl mx-auto w-full">
      <div className="grid grid-cols-2 gap-4">
        {departments.map((d) => (
          <button
            key={d.id}
            onClick={() => onSelect(d.id)}
            className="flex items-center gap-4 min-h-[64px] p-5 rounded-2xl bg-white dark:bg-dark-card border border-slate-200 dark:border-dark-border hover:border-emerald-500/50 hover:shadow-xl transition-all text-left"
          >
            <span className="text-3xl leading-none" aria-hidden>{emojiForDepartment(d.name)}</span>
            <span className="font-black text-slate-900 dark:text-white leading-tight">{d.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryTiles;
